import Widget from './WidgetWrapper';
export default Widget;
